// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file Enumerations/TimeTrackingRole.proto (package time_tracking.enumerations, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";
import { file_Options_EnumValueOptions } from "../Options/EnumValueOptions_pb";

/**
 * Describes the file Enumerations/TimeTrackingRole.proto.
 */
export const file_Enumerations_TimeTrackingRole: GenFile = /*@__PURE__*/
  fileDesc("CiNFbnVtZXJhdGlvbnMvVGltZVRyYWNraW5nUm9sZS5wcm90bxIadGltZV90cmFja2luZy5lbnVtZXJhdGlvbnMqqwEKEFRpbWVUcmFja2luZ1JvbGUSIgoeVElNRV9UUkFDS0lOR19ST0xFX1VOU1BFQ0lGSUVEEAASPQogVElNRV9UUkFDS0lOR19ST0xFX0FETUlOSVNUUkFUT1IQARoXwsfNDxIJ7hF4dNzHUUIRg/zYKad34b8SNAoXVElNRV9UUkFDS0lOR19ST0xFX1VTRVIQAhoXwsfNDxIJWE2qkO/sSUQRoRYXgQKeWB5CKKoCJU1vZ2kuVGltZVRyYWNraW5nLkNvbW1vbi5FbnVtZXJhdGlvbnNiBnByb3RvMw", [file_Options_EnumValueOptions]);

/**
 * Contains the roles used in the application and sent over identity and access tokens.
 *
 * @generated from enum time_tracking.enumerations.TimeTrackingRole
 */
export enum TimeTrackingRole {
  /**
   * No role value is available.
   *
   * @generated from enum value: TIME_TRACKING_ROLE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Administrator user that has access to all parts of the application.
   *
   * @generated from enum value: TIME_TRACKING_ROLE_ADMINISTRATOR = 1;
   */
  ADMINISTRATOR = 1,

  /**
   * Regular user that has access to a restricted subset of the application.
   *
   * @generated from enum value: TIME_TRACKING_ROLE_USER = 2;
   */
  USER = 2,
}

/**
 * Describes the enum time_tracking.enumerations.TimeTrackingRole.
 */
export const TimeTrackingRoleSchema: GenEnum<TimeTrackingRole> = /*@__PURE__*/
  enumDesc(file_Enumerations_TimeTrackingRole, 0);

